import type { ReactNode, JSX } from 'react';
import {
  Textarea,
  type TextareaProps,
} from '@doxyme/ui/components/foundations';
import { useTextboxStyles } from './inviteViaTextbox.styles';

export type InviteViaTextboxProps = {
  staticContent?: ReactNode;
  textareaHeight?: number | string;
} & TextareaProps;

export const InviteViaTextbox = ({
  staticContent,
  textareaHeight,
  hasError = false,
  disabled = false,
  ...textAreaProps
}: InviteViaTextboxProps): JSX.Element => {
  const styles = useTextboxStyles({ hasError, textareaHeight, disabled });

  return (
    <div css={styles.wrapper}>
      <Textarea
        hideErrorAlert={true}
        hasError={hasError}
        disabled={disabled}
        noResize={Boolean(textareaHeight)}
        css={styles.textarea}
        {...textAreaProps}
      />
      <div css={styles.staticContent} data-testid='invite-via-static-content'>
        {staticContent}
      </div>
    </div>
  );
};
